<!--  Start container for Firm Library -->
<ng-container *ngIf="showTemplateView && !isMasterTab">
    <div class="page-wraper" appSpin [spinnerConfig]='spinnerConfig()'>
        <div class="page-title-block bg-white pt-0">
            <div class="title-left">
                <h1 class="title h2">{{leadSheetName}}</h1>
            </div>
            <div class="title-right button-group">
                <ng-container *ngIf="enableCancelSave">
                    <button mat-button mat-stroked-button color="dark" class="bbutton-default"
                        (click)="cancelSave()" [disabled]="acl?.isSupport">Cancel
                    </button>
                    <button mat-button mat-flat-button color="primary" class="button-default"
                        (click)="updateReviewTemplateJSON('Worksheet updated Successfully')"
                        [disabled]="!isDescriptionEmpty" [disabled]="acl?.isSupport">Save
                    </button>
                </ng-container>
            </div>
        </div>

        <div class="content-block-main gap-32">
            <div class="card">
                <div class="card-body form-group flex-row flex-wrap row-item-3">
                    <mat-form-field class="form-item fixed-label">
                        <mat-label>LS Name</mat-label>
                        <mat-select [(ngModel)]="leadSheetName" [disabled]="true">
                            <mat-option [value]="leadSheetName">{{leadSheetName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <ng-container>
                        <mat-form-field class="form-item fixed-label">
                            <mat-label>LS Account Balance</mat-label>
                            <input matInput type="text" placeholder="LS Account Balance" [ngModel]="(leadsheetBalance|number:'1.2-2'|minusSignToParenthesis)" disabled>
                        </mat-form-field>
                    </ng-container>
                    <mat-form-field class="form-item fixed-label">
                        <mat-label>Materiality</mat-label>
                        <input matInput type="text" placeholder="Materiality" [ngModel]="(materialityValue|number:'1.2-2'|minusSignToParenthesis)" disabled>
                    </mat-form-field>
                </div>
                <div class="card-footer pt-0">
                    <div class="button-group w-100 justify-content-end">
                        <button mat-button mat-stroked-button color="dark" class="button-default"
                            [disabled]="!isViewChange || isView" (click)="hideProcedures()">
                            <span class="flexbox-row gap-8">
                                <i class="fa-regular fa-eye-slash"></i>
                                <span class="button-label">Hide</span>
                            </span>
                        </button>
                        <button mat-button mat-stroked-button color="dark" class="button-default"
                            [disabled]="!isViewChange || isView" (click)="deletProcedures()">
                            <span class="flexbox-row gap-8">
                                <i class="fa-regular fa-trash-can"></i>
                                <span class="button-label">Delete</span>
                            </span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body p-0">
                    <div class="table-responsive" style="max-height: 500px;">
                        <table id="tableProcedures" mat-table [dataSource]="dataSource"
                            class="table-countable dragable-column-table checkbox-table vertical-align-top cash-table">

                            <!-- Checkbox Column -->
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef style="width:36px;max-width:36px;">
                                    <mat-checkbox (change)="($event ? toggleAllRows() : null);"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                                        [aria-label]="checkboxLabel()"
                                        [disabled]="isView || hiddenSelection.hasValue() || engagementData.statusid === 19 || acl?.isSupport">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row" style="width:36px;max-width:36px;">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="($event ? selection.toggle(row) : null);hideSaveCancel()"
                                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)"
                                        [disabled]="isView || hiddenSelection.hasValue() || engagementData.statusid === 19 || acl?.isSupport">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <!-- Nature Column -->
                            <ng-container matColumnDef="nature">
                                <th mat-header-cell *matHeaderCellDef style="min-width:160px;max-width:160px;">Nature
                                </th>
                                <td mat-cell *matCellDef="let element" style="min-width:160px;max-width:160px;">
                                    <mat-form-field class="form-item fixed-label label-none w-100">
                                        <mat-label>Nature</mat-label>
                                        <mat-select [disableOptionCentering]="true" [(value)]="element.nature"
                                            [disabled]="isView || engagementData.statusid === 19 || acl?.isSupport" (selectionChange)="changeVal(element.nature, 'nature', element);"
                                            [ngClass]="{'emptySelect': !element.nature}">
                                            <mat-option title="{{name.value}}" *ngFor="let name of natureDate"
                                                value="{{name.key}}">
                                                {{name.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <!-- Type Column -->
                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef style="min-width:160px;max-width:160px;">Type</th>
                                <td mat-cell *matCellDef="let element" style="min-width:160px;max-width:160px;">
                                    <mat-form-field class="form-item fixed-label label-none w-100">
                                        <mat-label>Type</mat-label>
                                        <mat-select [disableOptionCentering]="true" [(value)]="element.type"
                                            [disabled]="isView || engagementData.statusid === 19 || acl?.isSupport" (selectionChange)="changeVal(element.type, 'type', element);"
                                            [ngClass]="{'emptySelect': !element.type}">
                                            <mat-option title="{{name.value}}" *ngFor="let name of typesData"
                                                value="{{name.key}}">
                                                {{name.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <!-- Description Column -->
                            <ng-container matColumnDef="description">
                                <th mat-header-cell *matHeaderCellDef style="min-width:380px;max-width:380px;">
                                    Description
                                </th>
                                <td mat-cell *matCellDef="let element" style="min-width:380px;max-width:380px;">
                                    <div [ngClass]="{ 'disabled-mat-field':(engagementData.statusid === 19 || acl?.isSupport) ,'emptyDescription' : !element.description , 'descriptionTbl': element.description}"
                                        *ngIf="!element.isDescEdited">
                                        <p class="description br-8 border-gray-3 gap-8 w-100" style="min-height: 96px;"
                                            (click)="(engagementData.statusid === 19  || acl?.isSupport) ? '' : editDescription(element)" [innerHTML]="element.description"></p>
                                    </div>
                                    <mat-form-field class="form-item fixed-label label-none form-textarea w-100"
                                        *ngIf="element.isDescEdited">
                                        <mat-label>Description</mat-label>
                                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                            cdkAutosizeMinRows="2" type="text" placeholder="Enter your description here"
                                            [(ngModel)]="element.description" [disabled]="isView || engagementData.statusid === 19 || acl?.isSupport"
                                            required [ngClass]="{'highlight-red': !element.description, 'disabled':engagementData.statusid === 19 || acl?.isSupport}"
                                            (blur)="changeVal(element.description, 'description', element);element.isDescEdited = false;"></textarea>
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <!-- Comments Column -->
                            <ng-container matColumnDef="comments">
                                <th mat-header-cell *matHeaderCellDef style="min-width:380px;max-width:380px;">Comments
                                </th>
                                <td mat-cell *matCellDef="let element;let i=index"
                                    style="min-width:380px;max-width:380px;">
                                    <div class="parent-div border br-8"
                                         [ngClass]="{ 'disabled':engagementData.statusid === 19 || acl?.isSupport}">
                                        <mat-form-field class="form-item fixed-label label-none form-textarea w-100"
                                            floatLabel="always">
                                            <mat-label>Comments</mat-label>
                                            <textarea matInput cdkTextareaAutosize class="border-0"
                                                #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" type="text"
                                                placeholder="Enter your comments here" [(ngModel)]="element.comments"
                                                [disabled]="isView || engagementData.statusid === 19 || acl?.isSupport" (keyup)="onEditTemplate()"
                                                (blur)="updateCommentDetails(element);" style="box-shadow: none;">
                                            </textarea>
                                        </mat-form-field>
                                        <p class="p-2 px-10 fs-12" *ngIf="element.isCommentAvailable && element.comments.trim()">
                                            Last update by {{element.auther}} <br>
                                            Dated {{element.created | appCountableTimeZone:'MMM dd, yyyy hh:mm a' }}
                                        </p>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- W/P Ref Column -->
                            <ng-container matColumnDef="wpref">
                                <th mat-header-cell *matHeaderCellDef style="width:150px;max-width:150px;">
                                    W/P Ref
                                </th>
                                <td *matCellDef="let element;let i=index;" class="row-hover-effect"
                                    style="width:150px;">
                                    <div class="flexbox-row justify-content-start">
                                        <button mat-button [matMenuTriggerFor]="refmenu" #referenceMenu="matMenuTrigger"
                                            class="button-text text-ellipse" (click)="$event.stopPropagation()" [disabled]="engagementData.statusid === 19 || acl?.isSupport">
                                            <ng-container *ngFor="let ref of element.wpRef; let i = index">
                                                <span *ngIf="i < 2" style="padding-right:1px;">
                                                    <span>
                                                        {{ checkPrefix(ref.REF ? ref.REF : ref.prefix) }}
                                                    </span>
                                                    <span *ngIf="element.wpRef.length > 1 && (i === 0)">,</span>
                                                </span>
                                            </ng-container>
                                            <ng-container *ngIf="element.wpRef && element.wpRef.length > 2">
                                                <i class="fa-solid fa-angle-down fs-15"></i>
                                            </ng-container>
                                        </button>
                                        <ng-container *ngIf="!element.wpRef || !element.wpRef.length">
                                            <span>-</span>
                                        </ng-container>
                                        <mat-menu #refmenu="matMenu" xPosition="before" yPosition="below"
                                            class="ref-menu-main">
                                            <div class="overflow-auto" style="max-height:300px;"
                                                (click)="$event.stopPropagation()">
                                                <mat-list role="list" class="templates-list-item p-0">
                                                    <mat-list-item role="listitem" *ngFor="let refDoc of element.wpRef"
                                                        title="{{refDoc.userdocname}}">
                                                        <div class="list-item-content cursor-default"
                                                            (click)="referenceMenu.closeMenu()">
                                                            <p appFilePreview [fileData]="refDoc" [inline]="false"
                                                                class="item-title">
                                                                {{refDoc.userdocname || refDoc.filename}}
                                                            </p>
                                                            <button mat-button class="button-text hover-action-item"
                                                                [disabled]="isView || enableCancelSave || engagementData.statusid === 19 || acl?.isSupport"
                                                                (click)="removeSelectedFile(i,refDoc.engteamclientdocid,element);referenceMenu.closeMenu()">
                                                                <i class="fa-regular fa-trash-can"></i>
                                                            </button>
                                                        </div>
                                                    </mat-list-item>
                                                </mat-list>
                                            </div>
                                        </mat-menu>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Status Column -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef class="text-center"
                                    style="width: 100px;max-width: 100px;">Status
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-center"
                                    style="width: 100px;max-width: 100px;" [disabled]="isView">
                                    <i class="fa-regular fa-circle-check text-success" *ngIf="element.isCommentAvailable"></i>
                                    <span *ngIf="!element.isCommentAvailable">{{'-'}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions" stickyEnd>
                                <th mat-header-cell *matHeaderCellDef class="text-center"
                                    style="max-width: 100px;width: 100px;">
                                    Actions
                                </th>
                                <td mat-cell *matCellDef="let element;let i = index"
                                    style="max-width: 100px;width: 100px;">
                                    <div class="flexbox-row justify-content-center gap-12 py-2">
                                        <button mat-button class="button-text transparent-btn"
                                            (click)="handleChangeOnRefClick('element',i,element)"
                                            [disabled]="isView || enableCancelSave || engagementData.statusid === 19 || acl?.isSupport">
                                            <i class="fa-regular fa-file-plus"></i>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row class="procTableClss" *matRowDef="let row; columns: displayedColumns;let i=index;" [hidden]="row.isEmptyRow" cdkDropList
                            (cdkDropListDropped)="handleDropToMiddleFiles($event, row)"></tr>
                        </table>
                    </div>
                </div>
                <div class="card-footer border-top">
                    <div class="button-group">
                        <button (click)="addProcedures()" mat-button mat-flat-button color="primary"
                            class="button-default" [disabled]="isView || isAddRowBtnEnabled() || engagementData.statusid === 19 || acl?.isSupport">
                            <span class="flexbox-row gap-8">
                                <i class="fa-solid fa-plus"></i>
                                <span class="button-label">Add Row</span>
                            </span>
                        </button>
                    </div>
                </div>
            </div>


            <div class="confimation-block">
                <h5 class="title">Please tick the checkbox as applicable</h5>
                <div class="confer-inner d-flex flex-row flex-nowrap align-items-start justify-content-between w-100">
                    <p class="me-3">Has any matter come to our attention in completing the procedures above that has
                        caused us to believe the financial
                        statements are not presented fairly in all material aspects or if there are any other reasons to
                        perform additional procedures,
                        please click on the checkbox</p>
                    <mat-checkbox (change)="onCheckboxChange($event)" [checked]="isAdditionalProcedure==1"
                        [disabled]="routeUrl.includes('/view-procedures') || engagementData.statusid === 19 || acl?.isSupport">
                    </mat-checkbox>
                </div>
            </div>
            <div class="form-group">
                <mat-form-field class="form-item fixed-label w-100">
                    <mat-label>Conclusion</mat-label>
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"
                        type="text" placeholder="Conclusion" [(ngModel)]="TemplateData.conclusion"
                        (input)="enableCancelSave=true" [disabled]="isView || engagementData.statusid === 19 || acl?.isSupport"></textarea>
                </mat-form-field>
                <div class="button-group form-item w-100 justify-content-end">
                    <!-- matTooltip="Please add comments or W/P Ref to all the available rows to conclude" [matTooltipDisabled]="!concludeWorksheet" -->
                    <button mat-button mat-flat-button color="primary" class="button-default hover-action"
                        *ngIf="!isClicked" (click)="concludeWorksheets()" [disabled]="concludeWorksheet || engagementData.statusid === 19 || acl?.isSupport">
                        {{TemplateData.isConcluded != null ? 'Re-conclude worksheet' : 'Conclude Worksheet'}}
                        <p class="custom-tooltip-left hover-action-item">Please add comments or W/P Ref to all the
                            available rows to conclude</p>
                    </button>
                    <button mat-button mat-flat-button color="primary" class="button-default" *ngIf="isVisible" [disabled]="engagementData.statusid === 19 || acl?.isSupport"
                        (click)="reopenWorksheet()">
                        Reopen worksheet
                    </button>
                    <span *ngIf="isShow">
                        <i class="fa-regular fa-circle-check text-success"></i>
                        <span class="concluded-group"> Concluded
                            Worksheet</span><br>{{TemplateData.concluderUser.userName}}
                        |{{TemplateData.concluderUser.timing | appCountableTimeZone:'MMM dd, yyyy hh:mm a'}}
                    </span>
                    <span
                        *ngIf="!TemplateData?.isConcluded && TemplateData?.isConcluded !== null && TemplateData?.isConcluded !== undefined">
                        <i class="fa-regular fa-circle-info text-primary"></i>
                        <span class="reopen-group"> Reopen Worksheet</span><br>{{TemplateData.reopenedUser.userName
                        }}|{{TemplateData.reopenedUser.timing | appCountableTimeZone:'MMM dd, yyyy hh:mm a'}}
                    </span>
                </div>
            </div>

            <mat-expansion-panel class="card" [expanded]="panelOpenState">
                <mat-expansion-panel-header class="card-header">
                    <h5 class="title">Hidden Rows</h5>
                    <div class="button-group w-auto">
                        <button mat-button mat-stroked-button color="dark" [disabled]="isRestore || isView || engagementData.statusid === 19 || acl?.isSupport"
                            (click)="restoreProcedures()" class="button-default ">
                            <span class="flexbox-row gap-8">
                                <i class="fa-regular fa-arrow-rotate-left"></i>
                                <span class="button-label">Restore</span>
                            </span>
                        </button>
                        <button mat-button mat-stroked-button color="dark" [disabled]="isRestore || isView || engagementData.statusid === 19 || acl?.isSupport"
                            (click)="deletHiddenProcedures()" class="button-default">
                            <span class="flexbox-row gap-8">
                                <i class="fa-regular fa-trash-can"></i>
                                <span class="button-label">Delete</span>
                            </span>
                        </button>
                        <button mat-button class="toogle-button" (click)="togglePanel" [disabled]="isView || engagementData.statusid === 19 || acl?.isSupport">Toogle
                        </button>
                    </div>
                </mat-expansion-panel-header>
                <div class="card-body p-0">
                    <div class="table-responsive" style="max-height:500px;">
                        <table mat-table [dataSource]="hiddenDataSource"
                            class="table-countable dragable-column-table checkbox-table vertical-align-top cash-table">
                            <!--                            dragable Column-->
                            <!--                            <ng-container matColumnDef="dragable">-->
                            <!--                                <th mat-header-cell *matHeaderCellDef></th>-->
                            <!--                                <td mat-cell *matCellDef="let row">-->
                            <!--                                    <span class="dragable-icon">-->
                                                                 <!-- <i class="fa-solid fa-grip-dots-vertical"></i> -->
                            <!--                                    </span>-->
                            <!--                                </td>-->
                            <!--                            </ng-container>-->
                            <!-- Checkbox Column -->
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef style="width:36px;max-width:36px;">
                                    <mat-checkbox class="label-none" (change)="$event ? toggleAllHiddenRows() : null"
                                        [checked]="hiddenSelection.hasValue() && isAllHiddenRowsSelected()"
                                        [indeterminate]="hiddenSelection.hasValue() && !isAllHiddenRowsSelected()"
                                        [aria-label]="hiddenCheckboxLabel()"
                                        [disabled]="isView || selection.hasValue() || engagementData.statusid === 19 || acl?.isSupport">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row" style="width:36px;max-width:36px;">
                                    <mat-checkbox class="label-none" (click)="$event.stopPropagation()"
                                        (change)="$event ? hiddenSelection.toggle(row) : null"
                                        [checked]="hiddenSelection.isSelected(row)" [aria-label]="hiddenCheckboxLabel()"
                                        [disabled]="isView || selection.hasValue() || engagementData.statusid === 19 || acl?.isSupport">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <!-- Nature Column -->
                            <ng-container matColumnDef="nature">
                                <th mat-header-cell *matHeaderCellDef style="min-width:160px;max-width:160px;">Nature
                                </th>
                                <td mat-cell *matCellDef="let element" style="min-width:160px;max-width:160px;">
                                    <mat-form-field class="form-item fixed-label label-none w-100">
                                        <mat-label>Nature</mat-label>
                                        <mat-select disabled [(value)]="element.nature" disabled>
                                            <mat-option *ngFor="let name of natureDate" value="{{name.key}}">
                                                {{name.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <!-- Type Column -->
                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef style="width:160px;max-width:160px;">Type</th>
                                <td mat-cell *matCellDef="let element" style="width:160px;max-width:160px;">
                                    <mat-form-field class="form-item fixed-label label-none w-100">
                                        <mat-label>Type</mat-label>
                                        <mat-select disabled [(value)]="element.type" disabled>
                                            <mat-option *ngFor="let name of typesData" value="{{name.key}}">
                                                {{name.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <!-- Description Column -->
                            <ng-container matColumnDef="description">
                                <th mat-header-cell *matHeaderCellDef style="min-width:380px;max-width:400px;">
                                    Description
                                </th>
                                <td mat-cell *matCellDef="let element" style="min-width:380px;max-width:400px;">
                                    <p class="description br-8 border-gray-3 gap-8 w-100 disabled"
                                        style="min-height: 96px;" [innerHTML]="element.description"></p>
                                </td>
                            </ng-container>

                            <!-- Comments Column -->
                            <ng-container matColumnDef="comments">
                                <th mat-header-cell *matHeaderCellDef style="min-width:380px;max-width:400px;"> Comments
                                </th>
                                <td mat-cell *matCellDef="let element" style="min-width:380px;max-width:400px;">
                                    <mat-form-field class="form-item fixed-label label-none form-textarea w-100">
                                        <mat-label>Comments</mat-label>
                                        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                            cdkAutosizeMinRows="2" type="text" placeholder="Comments"
                                            [(ngModel)]="element.comments" disabled></textarea>
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <!-- W/P Ref Column -->
                            <ng-container matColumnDef="wpref">
                                <th mat-header-cell *matHeaderCellDef style="width:150px;max-width:150px;">
                                    W/P Ref
                                </th>
                                <td mat-cell *matCellDef="let element" style="width:150px;max-width:150px;">
                                    <button mat-button mat-stroked-button color="primary" class="button-default"
                                        disabled>
                                        <div class="flexbox-row gap-8">
                                            <i class="fa-solid fa-plus text-primary"></i>
                                            <span class="button-label">Ref</span>
                                        </div>
                                    </button>
                                </td>
                            </ng-container>

                            <!-- Status Column -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef class="text-center"
                                    style="min-width: 100px;max-width: 100px;"> Status
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-center"
                                    style="min-width: 100px;max-width: 100px;">
                                    {{element.status || '-'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions" stickyEnd>
                                <th mat-header-cell *matHeaderCellDef class="text-center"
                                    style="max-width: 100px;width: 100px;">
                                    Actions
                                </th>
                                <td mat-cell *matCellDef="let element;let i = index"
                                    style="max-width: 100px;width: 100px;">
                                    <div class="flexbox-row justify-content-center gap-12 py-2">
                                        <button mat-button class="button-text transparent-btn" [disabled]="engagementData.statusid === 19 || acl?.isSupport">
                                            <i class="fa-regular fa-file-plus"></i>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </div>
</ng-container>
<!--  End container for Firm Library -->

<!--Cancel Button Dialog-->
<ng-template #cancelTemplateDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            </span>
            <h4 class="title">Discard changes</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>Changes made to the worksheet must be lost.</p>
            <p>Are you sure you want to discard changes?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">No
            </button>
            <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]="true">Yes
            </button>
        </div>
    </div>
</ng-template>

<!--Delete Template Dialog-->
<ng-template #deleteTemplateDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-trash-can text-error"></i>
            </span>
            <h4 class="title">Delete</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>Are you sure want to delete this row ? This action will permanently remove it from the system.</p>
            <p>If you want to hide it instead and restore it later, please use the Hide function</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">Cancel
            </button>
            <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="true">Delete
            </button>
        </div>
    </div>
</ng-template>

<!--Hidden Delete Template Dialog-->
<ng-template #deleteHiddenTemplateDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-trash-can text-error"></i>
            </span>
            <h4 class="title">Delete</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>Deleting rows will permanently remove from the system.</p>
            <p>Are you sure you want to continue?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">Cancel
            </button>
            <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="true">Delete
            </button>
        </div>
    </div>
</ng-template>

<!--Add Reference Dialog-->
<ng-template #addRefrence id="addReferance">
    <div class="countable-dialog add-ref-dialog overflow-auto" style="width:800px;max-width:100%;">
        <div mat-dialog-title class="dialog-header">
            <div class="header-left">
                <span class="badge badge-primary badge-circle icon-bordered-primary">
                    <i class="fa-regular fa-circle-info text-primary"></i>
                </span>
                <div class="flexbox-column gap-8">
                    <h4 class="title">Add Reference</h4>
                    <p>Search and Add References</p>
                </div>
            </div>

            <button mat-button class="close" [mat-dialog-close]="false" (click)="cancelAddReference()">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content overflow-visible">
            <div class="horizontal-items gap-8">
                <h6 class="label">Choose Section Type</h6>

                <mat-radio-group class="horizontal-items gap-32 radio-group">
                    <mat-radio-button id="leftDoc" value="1" (change)="onSeletionChange($event)" checked>
                        Left Section Documents
                    </mat-radio-button>
                    <mat-radio-button id="rightDoc" value="2" (change)="onSeletionChange($event)">
                        Right Section Documents (Under Available)
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="ng-form-field label-none w-100 required" *ngIf="selectedSection === '1'">
                <label>Select or Search Documents to be added</label>
                <ng-select [items]="referenceDocLeftSideList" bindLabel="filename" [bindValue]="engteamclientdocid"
                    [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedLeftDocs" placeholder="Search here"
                    [searchable]="selectedLeftDocs.length > 2 ? false : true" (change)="onDocSelectionChange()">

                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="badge badge-small badge-pills badge-primary badge-border gap-2 me-1"
                            style="width:80px;" title="{{item.filename}}" *ngFor="let item of items | slice:0:2">
                            <span class="text-ellipse">{{item.filename}}</span>
                            <button mat-button class="button-text" aria-hidden="true" (click)="clear(item)">
                                <i class="fa-regular fa-xmark text-error"></i>
                            </button>
                        </div>
                        <span class="ng-value-label" *ngIf="items.length > 2">+{{items.length - 2}} more</span>
                    </ng-template>

                    <ng-template ng-header-tmp>
                        <div class="vertical-items justify-content-between align-items-center py-2">
                            <div
                                class="custom-checkbox w-auto h-auto vertical-items align-items-center gap-4 cursor-pointer">
                                <input class="custom-checkbox-input" type="checkbox" [disabled]="isSelectAllDisabled(referenceDocLeftSideList)"
                                    (change)="onSelectAllLeftSide($event)" [ngModel]="isLeftSideSelectAll">
                                <span class="check-box">
                                    <i class="fa-regular fa-check text-primary"></i>
                                </span>
                                <label for="" class="title m-0">Select All</label>
                            </div>
                            <button mat-button class="button-text" (click)="onClearAllLeftSide()">
                                Clear All
                            </button>
                        </div>
                    </ng-template>


                    <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                        <div class="horizontal-items gap-4 px-2">
                            <div class="custom-checkbox gap-4 align-items-start">
                                <input class="custom-checkbox-input" id="item-{{index}}" type="checkbox"
                                    [disabled]="item$.disabled" [ngModel]="item$.selected">
                                <span class="check-box">
                                    <i class="fa-regular fa-check text-primary"></i>
                                </span>
                                <div class="flexbox-column gap-0">
                                    <label for="" class="title m-0">{{item.filename}}</label>
                                    <p class="text-ellipse fs-12">{{item.sectionpath}}</p>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-select>
            </div>

            <div class="ng-form-field label-none w-100 required" *ngIf="selectedSection === '2'">
                <label>Select or Search Documents to be added</label>
                <ng-select [items]="referenceDocRightSideList" bindLabel="filename" [bindValue]="engteamclientdocid"
                    [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedRightDocs" placeholder="Select"
                    [searchable]="selectedRightDocs.length > 2 ? false : true" (change)="onDocSelectionChange()">

                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="badge badge-small badge-pills badge-primary badge-border gap-2 me-1"
                            style="width:80px;" title="{{item.filename}}" *ngFor="let item of items | slice:0:2">
                            <span class="text-ellipse">{{item.filename}}</span>
                            <button mat-button class="button-text" aria-hidden="true" (click)="clear(item)">
                                <i class="fa-regular fa-xmark text-error"></i>
                            </button>
                        </div>
                        <span class="ng-value-label" *ngIf="items.length > 2">+{{items.length - 2}} more</span>
                    </ng-template>

                    <ng-template ng-header-tmp>
                        <div class="vertical-items justify-content-between align-items-center py-2">
                            <div
                                class="custom-checkbox w-auto h-auto vertical-items align-items-center gap-4 cursor-pointer">
                                <input class="custom-checkbox-input" type="checkbox" [disabled]="isSelectAllDisabled(referenceDocRightSideList)"
                                    (change)="onSelectAllRightSide($event)" [ngModel]="isRightSideSelectAll">
                                <span class="check-box">
                                    <i class="fa-regular fa-check text-primary"></i>
                                </span>
                                <label for="" class="title m-0">Select All</label>
                            </div>
                            <button mat-button class="button-text" (click)="onClearAllRightSide()">
                                Clear All
                            </button>
                        </div>
                    </ng-template>


                    <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                        <div class="horizontal-items gap-4 px-2">
                            <div class="custom-checkbox gap-4 align-items-start">
                                <input class="custom-checkbox-input" id="item-{{index}}" type="checkbox"
                                    [disabled]="item$.disabled" [ngModel]="item$.selected">
                                <span class="check-box">
                                    <i class="fa-regular fa-check text-primary"></i>
                                </span>
                                <div class="flexbox-column gap-0">
                                    <label for="" class="title m-0">{{item.filename}}</label>
                                    <p class="text-ellipse fs-12">{{item.sectionpath}}</p>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="flexbox-column gap-8">
                <h6 class="title">Selected References</h6>
                <div class="card">
                    <mat-list role="list" class="selected-ref templates-list-item p-0" style="max-height:12vh;overflow:auto;">
                        <div class="no-ref-added" *ngIf="!(referenceDocList?.length > 0)">Selected documents will be
                            visible here
                        </div>
                        <mat-list-item role="listitem" *ngFor="let ref of referenceDocList">
                            <div class="list-item-content cursor-default">
                                <div class="title-left flex-1">

                                    <h6 class="title text-ellipse fs-12">{{ref.filename}}</h6>
                                    <p class="fs-12 text-gray-7">{{ref.sectionpath}}</p>
                                </div>
                                <button mat-button class="button-text" (click)="deleteReference(ref)">
                                    <i class="fa-regular fa-trash-can"></i>
                                </button>
                            </div>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
        </div>

        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]="false"
                (click)="cancelAddReference()">Cancel
            </button>
            <button mat-button mat-flat-button color="primary" class="button-default" [mat-dialog-close]="true"
                [disabled]="selectedSection == 1 ? selectedLeftDocs.length == 0 : selectedRightDocs.length == 0"
                (click)="selectedSection == '1' ? addReferenceDocList() : enableSDK()">Add
            </button>
        </div>
    </div>
</ng-template>


<!--Reopen Worksheet Dialog-->
<ng-template #reopenWorksheetDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            </span>
            <h4 class="title">Reopen worksheet</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>Are you sure you want to reopen worksheet?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">No
            </button>
            <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]="true">Yes
            </button>
        </div>
    </div>
</ng-template>
